import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Goals from "./Goals";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import RequiredCourseSet from "./RequiredCourseSet";
import "./StudentProgress.css";
const API_URL = process.env.REACT_APP_API_URL;
const OpenModal = ({
  data,
  isOpen,
  closeHandler
}) => {
  return <Fragment>
      <Modal isOpen={isOpen} toggle={closeHandler}>
        <ModalHeader>
          Required Course Set Mapping Uploaded Successfully!!!
        </ModalHeader>
        <ModalBody>
          <div style={{
          padding: "10px"
        }}>
            {data && <div style={{
            padding: "10px",
            background: "#fcf8e3"
          }}>
                <h4>Upload Course Map Error</h4>
                {data?.error?.map((item, idx) => <div key={idx} style={{
              color: "#607d8b",
              fontSize: "14px"
            }}>
                    {item}
                  </div>)}
              </div>}
            
          </div>
        </ModalBody>
        <ModalFooter>
          <button className="admin-ccplus-btn broadcast" onClick={closeHandler}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>;
};
const StudentProgress = () => {
  let history = useHistory();
  const [uploadCourseFile] = useState();
  const [dataAfterFileUpload, setDataAfterFileUpload] = useState();
  const [openModalAfterUpload, setOpenModalAfterUpload] = useState(false);
  const uploadFileHandler = () => {
    let formData = new FormData();
    formData.append("csvfilename", undefined);
    formData.append("csv_file", uploadCourseFile);
    fetch(`${API_URL}/api/v1/course/upload-file`, {
      method: "POST",
      headers: {
        "x-authorization": `Bearer ${localStorage.getItem("token")}`
      },
      body: formData
    }).then(response => response.json()).then(data => {
      setDataAfterFileUpload(data);
    }).catch(() => {});
  };
  useEffect(() => {
    if (uploadCourseFile) {
      uploadFileHandler();
    }
  }, [uploadCourseFile]);
  return <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="admin-ccplus-page">
            <div className="admin-ccplus-header">
              <div>
                <h1 className="admin-ccplus-title">Goal Editor</h1>
                <p className="admin-ccplus-subtitle">
                  Manage goals and required course sets for student progress
                </p>
              </div>
            </div>

            <div className="admin-ccplus-panels">
              <div className="admin-ccplus-panel">
                <Goals />
              </div>
              <div className="admin-ccplus-panel">
                <RequiredCourseSet />
              </div>
            </div>
          </div>

          {openModalAfterUpload && <OpenModal data={dataAfterFileUpload} isOpen={openModalAfterUpload} closeHandler={() => {
          setOpenModalAfterUpload(false);
          history.push("/admin/ccplus");
        }} />}

          
        </div>
      </div>
    </Fragment>;
};
export default StudentProgress;